module.exports = __webpack_public_path__ + "img/jwgl-kbcx-xskb.b04e1913.png";